module.exports = __webpack_public_path__ + "static/media/program_slider_phone3.ca9e06d5.png";